import { Chip } from "@mui/material";

import { ContextType } from "../contextType";

import { ContextIcon } from "./ContextIcon";
import styles from "./MoreContextChip.module.css";

interface MoreContextChipProps {
  count: number;
  contextType: ContextType;
  onClick: () => void;
}

const CONTEXT_TYPE_PLURAL_LABELS: Record<ContextType, string> = {
  dataset: "datasets",
  file: "files",
  viz_state: "panels",
};

/**
 * Chip that displays "N more files..." and expands the group on click.
 */
export const MoreContextChip = ({
  count,
  contextType,
  onClick,
}: MoreContextChipProps) => {
  const label = `${count} more ${CONTEXT_TYPE_PLURAL_LABELS[contextType]}`;

  return (
    <Chip
      icon={
        <ContextIcon contextType={contextType} className={styles.chipIcon} />
      }
      label={label}
      size="small"
      onClick={onClick}
      className={styles.chip}
      classes={{
        label: styles.chipLabel,
      }}
      sx={{
        "& .MuiChip-icon": {
          marginRight: "1px",
        },
      }}
    />
  );
};
